// extracted by mini-css-extract-plugin
export default {"button":"pagination_button__mixRs","active":"pagination_active__c4hm5"};